// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface SnapshotsListOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SnapshotsListByResourceGroupOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SnapshotsDeleteOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SnapshotsUpdateTagsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SnapshotsCreateOrUpdateOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface SnapshotsGetOptionalParams extends OperationOptions {}
